enum ModalToOpen {
	MergeConfirm = "MergeConfirm",
	MergeResolver = "MergeResolver",

	ShareTicketHandler = "ShareTicketHandler",
	ReviewTicketHandler = "ReviewTicketHandler",

	CheckoutHandler = "CheckoutHander",
	CloneHandler = "CloneHandler",
	Clone = "Clone",
	PullHandler = "PullHandler",

	SnippetAlreadyUseWarn = "SnippetAlreadyUseWarn",

	Loading = "Loading",

	MultilangActionConfirm = "MultilangActionConfirm",

	DiagramEditor = "DiagramEditor",
	HTMLEditor = "HTMLEditor",

	Merge = "Merge",
	CreateMergeRequest = "CreateMergeRequest",
	MergeRequestConfirm = "MergeRequestConfirm",
	CreateSourceData = "CreateSourceData",

	EditEnterpriseConfig = "EditEnterpriseConfig",

	TemplateContentWarning = "TemplateContentWarning",
	PropertySettings = "PropertySettings",

	DocRootMissingModal = "DocRootMissingModal",

	CloudModal = "CloudModal",

	CreateWorkspaceForm = "CreateWorkspaceForm",
	EditWorkspaceForm = "EditWorkspaceForm",
}

export default ModalToOpen;
